import React from "react";
import {
  SkeletonGrid,
  SkeletonCard,
  SkeletonCardHeader,
  SkeletonCardBody,
  SkeletonBodyItem,
  SkeletonChart,
} from "./index.styled";

const GeneralSummarySkeleton: React.FC = () => {
  return (
    <SkeletonGrid>
      {Array.from({ length: 4 }).map((_, cardIndex) => (
        <SkeletonCard key={cardIndex} $delay={cardIndex * 0.1}>
          <SkeletonCardHeader />
          <SkeletonCardBody>
            {Array.from({ length: 3 }).map((_, itemIndex) => (
              <SkeletonBodyItem key={itemIndex} $delay={itemIndex * 0.05}>
                <div className="skeleton-text">
                  <div className="skeleton-title" />
                  <div className="skeleton-value" />
                </div>
                <div className="skeleton-icon" />
              </SkeletonBodyItem>
            ))}
          </SkeletonCardBody>
          {cardIndex % 2 === 0 && <SkeletonChart />}
        </SkeletonCard>
      ))}
    </SkeletonGrid>
  );
};

export default GeneralSummarySkeleton;
